import { render, staticRenderFns } from "./popup-do.vue?vue&type=template&id=087e9ee5&scoped=true"
import script from "./popup-do.vue?vue&type=script&lang=js"
export * from "./popup-do.vue?vue&type=script&lang=js"
import style0 from "./popup-do.vue?vue&type=style&index=0&id=087e9ee5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087e9ee5",
  null
  
)

export default component.exports